import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import {
  Button,
  Container,
  Nav,
  Navbar,
  NavDropdown,
} from 'react-bootstrap';

import { useGetStartedModal } from '../context/GetStartedModalContext';
import BrandLogo from './BrandLogo';

const linkClass = ({ isActive }: { isActive: boolean }) =>
  `nav-link px-lg-3 ${isActive ? 'active' : ''}`;

const solutionRoutes = [
  { to: '/solutions/retingent-recruitment', label: 'Retingent Recruitment' },
  {
    to: '/solutions/pipelining-talent-infrastructure',
    label: 'Pipelining Talent Infrastructure',
  },
] as const;

export default function HeaderNav() {
  const { openGetStartedModal } = useGetStartedModal();
  const { pathname, hash } = useLocation();
  const [navExpanded, setNavExpanded] = useState(false);
  const closeNav = () => setNavExpanded(false);

  useEffect(() => {
    setNavExpanded(false);
  }, [pathname, hash]);

  const solutionsActive = pathname.startsWith('/solutions/');
  const resourcesActive = pathname.startsWith('/resources') || pathname.startsWith('/blog');
  const resourcesPodcastActive =
    pathname === '/resources' && hash !== '#blog';
  const resourcesBlogActive =
    pathname.startsWith('/blog') || (pathname === '/resources' && hash === '#blog');

  return (
    <Navbar
      variant="dark"
      bg="transparent"
      expand="lg"
      sticky="top"
      expanded={navExpanded}
      onToggle={setNavExpanded}
      className="sbr-navbar navbar-blur border-bottom border-secondary border-opacity-25 bg-sbr-navy"
    >
      <Container className="align-items-center">
        <BrandLogo variant="light" maxHeight={64} />
        <Navbar.Toggle aria-controls="sbr-main-nav" />
        <Navbar.Collapse id="sbr-main-nav">
          <Nav className="mx-lg-auto my-3 my-lg-0 align-items-lg-center">
            <NavLink className={linkClass} to="/" end onClick={closeNav}>
              Home
            </NavLink>
            <NavDropdown
              title="Solutions"
              id="nav-solutions"
              className={solutionsActive ? 'sbr-nav-dropdown--active' : undefined}
            >
              {solutionRoutes.map((item) => (
                <NavDropdown.Item
                  key={item.to}
                  as={NavLink}
                  to={item.to}
                  className={pathname === item.to ? 'active' : undefined}
                  onClick={closeNav}
                >
                  {item.label}
                </NavDropdown.Item>
              ))}
            </NavDropdown>

            <NavLink className={linkClass} to="/how-it-works" onClick={closeNav}>
              How It Works
            </NavLink>
            <NavLink className={linkClass} to="/roles-we-fill" onClick={closeNav}>
              Roles We Fill
            </NavLink>
            <NavLink className={linkClass} to="/industries" onClick={closeNav}>
              Industries
            </NavLink>

            <NavDropdown
              title="Resources"
              id="nav-resources"
              className={resourcesActive ? 'sbr-nav-dropdown--active' : undefined}
            >
              <NavDropdown.Item
                as={NavLink}
                to="/resources#podcasts"
                className={resourcesPodcastActive ? 'active' : undefined}
                onClick={closeNav}
              >
                Podcasts
              </NavDropdown.Item>
              <NavDropdown.Item
                as={NavLink}
                to="/blog"
                className={resourcesBlogActive ? 'active' : undefined}
                onClick={closeNav}
              >
                Blog
              </NavDropdown.Item>
            </NavDropdown>

            <NavLink className={linkClass} to="/about-us" onClick={closeNav}>
              About Us
            </NavLink>
          </Nav>

          <div className="sbr-nav-cta d-flex flex-column flex-sm-row gap-2 ms-lg-3 pb-3 pb-lg-0">
            <Button
              variant="outline-light"
              className="sbr-nav-cta__btn"
              onClick={() => {
                closeNav();
                openGetStartedModal();
              }}
            >
              Get Started
            </Button>
            <Button
              variant="secondary"
              className="sbr-nav-cta__btn"
              as={Link as any}
              to="/book-a-call"
              onClick={closeNav}
            >
              Book a Call
            </Button>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
